<template>
  <b-card class="card-painel">
    <b-row>
      <b-col cols="12">
        <b-row class="align-items-end">
          <b-col>
            <legend class="col-form-label pt-0">
              Funil
            </legend>

            <b-select
              v-model="funilSelecionado"
              name="funilSelecao"
              class="search-items"
              @change="selecionarFunil"
            >
              <option
                v-for="funil in funis"
                :key="funil.id"
                :value="funil.id"
              >
                {{ funil.name }}
              </option>
            </b-select>
          </b-col>

          <b-col
            cols="5"
            class="d-flex justify-content-end flex-wrap"
          >
            <cadastro-funil
              class="mr-50"
              @funil-criado="onFunilCriado"
            />
            <b-btn
              class="btn-primary btn-sm mr-50"
              @click="abrirModalCadastroEtapa"
            >
              <font-awesome-icon :icon="faPlus" />
              Nova etapa
            </b-btn>
            <b-btn
              class="btn-primary btn-sm mr-50"
              @click="abrirModalCadastroOportunidade"
            >
              <font-awesome-icon :icon="faPlus" />
              Nova oportunidade
            </b-btn>
          </b-col>
        </b-row>

        <b-modal
          ref="modalCadastroEtapa"
          title="Cadastre uma nova etapa"
          size="sm"
          no-close-on-background
          :footer-class="'custom-footer-class'"
          :dialog-class="'alteracao-tamanho'"
          :modal-class="'center-modal'"
        >
          <div
            style="display: flex; flex-direction: column; align-items: center; gap: 2rem;"
          >
            <b-input
              v-model="novaEtapa.name"
              name="inputNovoFunil"
              placeholder="Nome da etapa..."
              autofocus
              style="width: 63% !important;"
            />
            <div style="margin-bottom: 1rem;">
              <p
                style="font-weight: 300; font-size: 12px; margin-bottom: 0 !important;"
              >Escolha uma cor:</p>
              <chrome v-model="novaEtapa.color" />
            </div>
          </div>

          <template #modal-footer>
            <b-button
              block
              size="md"
              class="btn-criar"
              variant="primary"
              @click="cadastrarNovaEtapa"
            >
              Criar
            </b-button>
          </template>
        </b-modal>

        <b-modal
          ref="modalCadastroOportunidade"
          title="Cadastre uma nova oportunidade"
          size="md"
          no-close-on-backdrop
          :footer-class="'custom-footer-class'"
          :dialog-class="'alteracao-tamanho'"
          :modal-class="'center-modal'"
        >
          <div
            style="display: flex; flex-direction: column; align-items: center; gap: 1rem; width: 100%;"
          >
            <div
              style="width: 100%;"
            />

            <!-- <div>
                <label for="inputNovaOportunidadeValor">
                  Valor
                </label>
                <dinheiro-input
                  v-model="novaOportunidade.valor"
                  name="inputNovaOportunidadeValor"
                  :options="{ currency: 'BRL', precision: 2, hideNegligibleDecimalDigitsOnFocus: false, autoDecimalDigits: false}"
                />
              </div> -->
            <div style="width: 100%;">
              <empresa-cnpj-select
                v-model="novaOportunidade.company"
                :label="'Empresa'"
                :exibir-botao-criar-pessoa="false"
                :pessoa="novaOportunidade.person"
                @input="empresaSelecionadaViaCnpj"
                @empresa-criada="empresaSelecionadaViaCnpj"
                @pessoa-criada="pessoaCriada"
              />
            </div>

            <div>
              - ou -
            </div>

            <div style="width: 100%;">
              <div class="d-flex align-items-center">
                <label
                  for="pessoaSelect"
                  class="mb-0"
                >
                  Pessoa
                </label>
                <span
                  class="d-flex align-items-center justify-content-center"
                  style="width: 35px; height: 24px;"
                >
                  <b-button
                    v-b-tooltip.hover.top="'Criar pessoa responsável'"
                    size="sm"
                    variant="none"
                    class="btn-actions p-0"
                    style="width: 24px; height: 24px;"
                    @click="abrirModalCriarPessoa"
                  >
                    <font-awesome-icon
                      :icon="faPlus"
                      :class="'text-primary'"
                      style="width:18px"
                    />
                  </b-button>
                </span>
              </div>

              <pessoa-select
                ref="pessoaSelect"
                v-model="novaOportunidade.person"
                :label="''"
                style="width: 100%;"
              />
            </div>
          </div>

          <template #modal-footer>
            <b-button
              block
              size="md"
              class="btn-criar"
              variant="primary"
              @click="cadastrarNovaOportunidade"
            >
              Criar
            </b-button>
          </template>
        </b-modal>

        <modal-criar-pessoa
          ref="modalCriarPessoa"
          :empresa-id="novaOportunidade.company ? novaOportunidade.company.id : null"
          @pessoa-criada="pessoaCriada"
        />

        <div
          v-if="!funis || funis.length === 0"
          style="display: flex; justify-content: center; margin-top: 20px;"
        >
          <p style="font-style: italic; color: gray; font-size: 18px;">
            Cadastre um funil na lista de selecao para poder gerenciar suas oportunidades.
          </p>
        </div>

        <div
          v-else-if="funisEtapasOportunidades.stages.length === 0"
          style="display: flex; justify-content: center; margin-top: 20px;"
        >
          <p style="font-style: italic; color: gray; font-size: 18px; text-align: center;">
            Este funil não possui etapas cadastradas.
          </p>
        </div>

        <div class="quadro">
          <draggable
            v-model="funisEtapasOportunidades.stages"
            v-bind="dragOptions"
            tag="div"
            class="quadro-inner"
            group="stages"
            handle=".stage-handle"
            @change="onStageChanged( $event )"
          >
            <transition-group
              class="transition-wrapper"
              type="transition"
              :name="!drag ? 'flip-list' : null"
            >
              <div
                v-for="(stage, stageIndex) in funisEtapasOportunidades.stages"
                :key="stage.id || stageIndex"
                class="stage-column"
              >
                <div class="stage-header">
                  <p class="stageName">
                    {{ stage.name }}
                  </p>
                  <div>
                    <font-awesome-icon
                      :icon="faArrowsAlt"
                      class="stage-handle"
                      title="Arraste para mover a coluna"
                    />
                    <b-dropdown
                      size="sm"
                      variant="link"
                      no-caret
                    >

                      <template #button-content>
                        <font-awesome-icon
                          :icon="faPen"
                          title="Ações da etapa"
                        />
                      </template>
                      <b-dropdown-item
                        @click="deletarEtapa(stage)"
                      >
                        Excluir etapa
                      </b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>

                <div
                  class="stage-color-bar"
                  :style="{ backgroundColor: stage.color || '#ccc' }"
                />

                <draggable
                  v-model="stage.deals"
                  v-bind="dragOptions"
                  group="deals-group"
                  tag="div"
                  class="stage-deals-container"
                  @start="drag = true"
                  @end="drag = false"
                  @change="onDealChanged(stage, $event)"
                >
                  <transition-group
                    type="transition"
                    :name="!drag ? 'card-reorder' : null"
                  >
                    <div
                      v-for="(deal, cardIndex) in stage.deals"
                      :key="cardIndex"
                    >
                      <div
                        :class="['card-item', { 'card-atrasado': isDealOverdue(deal) }]"
                        @click="!drag && abrirModalDetalhesOportunidade(deal)"
                      >
                        <p class="card-title">
                          {{ deal.companyName || deal.personName || 'Não Informado' }}
                        </p>

                        <div class="card-body">
                          <div class="card-info">
                            <p v-if="deal.personName">
                              <strong>Cliente:</strong> {{ (deal.personName !== '') ? deal.personName : 'Não informado' }}
                            </p>
                          </div>
                        </div>

                        <div class="card-footer-expected">
                          <div class="card-owner">
                            <font-awesome-icon
                              :icon="faUser"
                              class="mr-1"
                              style="font-size: 10px;"
                            />
                            <span class="owner-name">{{ (deal.ownerName !== '') ? deal.ownerName : 'Não definido' }}</span>
                          </div>

                          <div
                            v-if="deal.proposalCount > 0"
                            class="card-value-badge"
                          >
                            <font-awesome-icon
                              :icon="faMoneyBillWave"
                              class="mr-1"
                              style="font-size: 10px;"
                            />
                            <span>{{ formatarValor(deal.proposalTotal) }}</span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div
                      v-if="stage.deals.length === 0"
                      key="empty"
                      class="empty-drop-zone"
                    >
                      <font-awesome-icon :icon="faArrowUp" />
                      <p>Arraste um card aqui</p>
                    </div>
                  </transition-group>
                </draggable>
              </div>
            </transition-group>
          </draggable>
        </div>
      </b-col>
    </b-row>
    <modal-detalhes-oportunidade
      ref="modalDetalhesOportunidade"
      :oportunidade-id="oportunidade.id"
    />
  </b-card>
</template>

<style>
.alteracao-tamanho {
  width: 1600px !important;
  max-width: 96vw !important;
}

.center-modal .modal-dialog {
  margin-top: 18px !important;
  margin-bottom: 18px !important;
}

.center-modal .modal-content {
  min-height: 70vh !important;
}

.center-modal .modal-body {
  padding-bottom: 18px !important;
}

.deal-header {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.deal-header-sub {
  font-size: 1.1rem;
  line-height: 1.15;
  color: #6c757d;
}

.deal-header-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 70vw;
}

.deal-header-cnpj {
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

.btn-copy-cnpj {
  line-height: 1;
  text-decoration: none !important;
}

.btn-copy-cnpj svg {
  font-size: 0.95rem;
}

.deal-header-address-link {
  display: inline-block;
  max-width: 70vw;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
  color: inherit;
  text-decoration: none;
  background-image: linear-gradient(currentColor, currentColor);
  background-position: 0 100%;
  background-repeat: no-repeat;
  background-size: 0% 2px;
  transition: background-size 220ms ease, transform 220ms ease, opacity 220ms ease;
  opacity: 0.95;
}

.deal-header-address-link:hover {
  background-size: 100% 2px;
  transform: translateX(2px);
  opacity: 1;
}

.empresa-info-wrapper {
  padding: 10px 10px 22px 10px;
}

.empresa-info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 20px;
  align-items: start;
}

.empresa-info-item {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.empresa-info-label {
  font-weight: 700;
  color: #111827;
  font-size: 14px;
  line-height: 1.2;
}

.empresa-info-value {
  font-weight: 400;
  color: #111827;
  font-size: 14px;
  line-height: 1.25;
}

.empresa-info-wrap {
  white-space: normal;
  word-break: break-word;
}

.empresa-info-muted {
  font-size: 13px;
  color: #6b7280;
}

.empresa-inline-input {
  width: 100%;
  border: 1px solid #e5e7eb;
  background: #fff;
  border-radius: 8px;
  padding: 8px 10px;
  font-size: 14px;
  color: #111827;
  outline: none;
  transition: box-shadow 160ms ease, border-color 160ms ease;
}

.empresa-inline-input:focus {
  border-color: #cbd5e1;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.12);
}

.empresa-inline-input--lateral {
  padding: 7px 10px;
  font-size: 13px;
  border-radius: 8px;
}

@media (max-width: 991px) {
  .empresa-info-grid {
    grid-template-columns: 1fr;
  }
}

.abas .card-header {
  justify-content: flex-start;
}

.abas > .card-header {
  padding-top: 3px !important;
  padding-bottom: 1px !important;
  min-height: unset !important;
}

.detalhe-modal {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.painel-info {
  border: 1px solid #e2e2e2;
  border-radius: 8px;
  padding: 16px;
  background: #f8f9fb;
}

.painel-conteudo {
  flex: 1;
}

.info-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
  margin-bottom: 12px;
}

.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.info-icon {
  color: #6c757d;
  font-size: 16px;
  margin-top: 3px;
}

.info-content {
  flex: 1;
  min-width: 0;
}

.info-label {
  display: block;
  font-size: 12px;
  font-weight: 600;
  color: #212529;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.info-value {
  font-weight: 400;
  color: #6c757d;
  margin-left: 0.3rem;
}

@media (min-width: 992px) {
  .detalhe-modal {
    flex-direction: row;
  }

  .painel-info {
    flex: 0 0 23%;
    max-width: 27%;
  }

  .painel-conteudo {
    flex: 0 0 73%;
    max-width: 73%;
    padding-left: 14px;
  }
}

.card-atrasado {
  background-color: #fff7f7;
  border: 1.5px solid #e96262;
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  transition: box-shadow 0.2s ease, border-color 0.2s ease;
}

.card-atrasado:hover {
  border-color: #e27c7c;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.06);
  background-color: #e55353;
}

.card-atrasado:hover,
.card-atrasado:hover p,
.card-atrasado:hover strong,
.card-atrasado:hover .card-value-badge,
.card-atrasado:hover .card-owner {
  transition: 0.3s;
  color: #ffffff !important;
}

.card-atrasado:hover .card-value-badge {
  background-color: rgba(255, 255, 255, 0.2);
  color: #ffffff;
}

.quadro {
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 10px;
  margin-top: 20px;
  height: calc(100vh - 260px);
  scrollbar-width: thin;
  scrollbar-color: rgba(0,0,0,0.2) transparent;
}

.quadro::-webkit-scrollbar {
  height: 8px;
}

.quadro::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 4px;
}

.quadro-inner {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
  min-width: max-content;
}

.transition-wrapper {
  display: flex;
  flex-wrap: nowrap;
  gap: 1rem;
}

.stage-column {
  flex: 0 0 340px;
  background: #f8f9fa;
  border-radius: 10px;
  padding: 1rem;
  height: calc(100vh - 300px);
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.stage-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}

.stage-handle {
  cursor: grab;
  color: #6c757d;
  transition: color 0.2s;
}

.stage-handle:hover {
  color: #343a40;
}

.stage-color-bar {
  height: 6px;
  width: 100%;
  border-radius: 4px;
  margin-bottom: 10px;
}

.stageName {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px;
}

.card-item {
  background: #fff;
  border-radius: 10px;
  margin-bottom: 1rem;
  box-shadow: 0 2px 6px rgba(0,0,0,0.08);
  transition: transform 0.15s ease, box-shadow 0.15s ease;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.card-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 10px rgba(0,0,0,0.12);
}

.card-title {
  padding: 0.8rem 1rem 0 1rem;
  font-size: 12px !important;
  font-weight: 600 !important;
  border-bottom: none !important;
  color: #212529;
  margin: 0;
  white-space: normal;
  word-break: break-word;
  line-height: 1.4;
  display: block;
}

.card-info {
  font-size: 12px !important;
  color: #495057;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.card-info p {
  margin: 0;
  line-height: 1.4;
}

.card-footer-expected {
  padding: 0.5rem 1rem !important;
  border-top: 1px solid #e4dbdb;
  display: flex;
  justify-content: space-between !important;
  align-items: center;
}

.card-value-badge {
  display: flex;
  align-items: center;
  background-color: #f1f3f5;
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  color: #495057;
}

.card-owner {
  font-size: 12px;
  color: #6c757d;
  display: flex;
  align-items: center;
  max-width: 60%;
}

.owner-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 4px;
}

.empty-drop-zone {
  min-height: 60px;
  border-top: 2px dashed #ccc;
  background: transparent;
  display: flex;
  align-items: baseline;
  gap: 1rem;
  padding-top: 1rem;
  justify-content: center;
  color: #aaa;
  font-size: 13px;
}
</style>

<script>
import {
  faPlus,
  faArrowsAlt,
  faArrowUp,
  faInfoCircle,
  faFolderOpen,
  faBuilding,
  faMoneyBillWave,
  faUser,
  faCalendarAlt,
  faClipboardList,
  faPen,
  faTimes,
  faSave,
  faClock,
  faBell,
  faCopy,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import draggable from 'vuedraggable'
import { Chrome } from 'vue-color'
import moment from 'moment'
import { getUserInfo } from '@/auth/utils'
import api from '@/app-modulo/comercial/oportunidades/shared/services/api'
import empresaApi from '@/app-modulo/comuns/empresa/shared/services/api'

export default {
  name: 'PainelOportunidades',
  components: {
    FontAwesomeIcon,
    draggable,
    Chrome,
    EmpresaCnpjSelect: () => import('@/shared/components/empresa-cnpj-select/EmpresaCnpjSelect.vue'),
    CadastroFunil: () => import('@/app-modulo/comercial/oportunidades/shared/components/cadastro-funil/CadastroFunil.vue'),
    PessoaSelect: () => import('@/shared/components/pessoa-select/PessoaSelect.vue'),
    ModalCriarPessoa: () => import('@/app-modulo/comercial/cadastro-proposta/shared/components/modal-criar-pessoa/ModalCriarPessoa.vue'),
    ModalDetalhesOportunidade: () => import('@/app-modulo/comercial/oportunidades/shared/components/modal-detalhes-oportunidade/ModalDetalhesOportunidade.vue'),
  },
  data() {
    return {
      faPlus,
      faArrowsAlt,
      faArrowUp,
      faInfoCircle,
      faFolderOpen,
      faBuilding,
      faMoneyBillWave,
      faUser,
      faCalendarAlt,
      faClipboardList,
      faPen,
      faTimes,
      faSave,
      faClock,
      faBell,
      faCopy,

      drag: false,
      funis: [],
      funisEtapasOportunidades: {
        stages: [],
      },
      funilSelecionado: null,
      novaEtapa: this.novaEtapaBase(),
      novaOportunidade: this.novaOportunidadeBase(),
      oportunidade: this.novaOportunidadeBase(),

      statusOpcoes: [
        { value: 'Em andamento', text: 'Em andamento' },
        { value: 'Concluida', text: 'Concluida' },
        { value: 'Perdida', text: 'Perdida' },
        { value: 'Aguardando cliente', text: 'Aguardando cliente' },
        { value: 'Cancelada', text: 'Cancelada' },
      ],
      propostaIdAtual: null,
    }
  },
  computed: {
    dragOptions() {
      return {
        animation: 200,
        group: 'description',
        disabled: false,
        ghostClass: 'ghost',
      }
    },

  },

  created() {
    this.funis = this.carregarFunis()
  },
  methods: {
    async onFunilCriado(novoFunil) {
      const novoFunilId = novoFunil && novoFunil.id ? novoFunil.id : null
      await this.carregarFunis(novoFunilId)
      this.novaEtapa = this.novaEtapaBase()
      this.$nextTick(() => {
        this.abrirModalCadastroEtapa()
      })
    },
    abrirModalCadastroEtapa() {
      this.$refs.modalCadastroEtapa.show()
    },

    carregarFunis() {
      this.$isLoading(true)
      api.getActivePipelines()
        .then(response => {
          this.funis = response.data
          const [primeiroFunil] = this.funis
          this.funilSelecionado = primeiroFunil.id
          this.carregarFunisEtapasOportunidades()
        })
        .catch(() => {
          this.$erro('Erro ao carregar funis, tente novamente mais tarde.')
        }).finally(() => {
          this.$isLoading(false)
        })
    },

    carregarFunisEtapasOportunidades(funilId = null) {
      const funilParaCarregar = funilId || this.funilSelecionado
      this.$isLoading(true)
      api.getPipelineWithStangesAndDeals(funilParaCarregar)
        .then(async response => {
          this.funisEtapasOportunidades = response.data

          if (this.funisEtapasOportunidades && Array.isArray(this.funisEtapasOportunidades.stages)) {
            this.funisEtapasOportunidades.stages.forEach(stage => {
              if (stage && Array.isArray(stage.deals)) {
                stage.deals.forEach(deal => {
                  this.$set(deal, 'proposalTotal', 0)
                  this.$set(deal, 'proposalCount', 0)
                })
              }
            })
          }

          await this.carregarTotaisPropostas()
        })
        .catch(() => {
          this.$erro(`Erro ao carregar etapas do funil ${funilParaCarregar}, tente novamente mais tarde.`)
        }).finally(() => {
          this.$isLoading(false)
        })
    },

    listarDealsDoQuadro() {
      const deals = []
      if (!this.funisEtapasOportunidades || !Array.isArray(this.funisEtapasOportunidades.stages)) return deals

      this.funisEtapasOportunidades.stages.forEach(stage => {
        if (stage && Array.isArray(stage.deals)) {
          stage.deals.forEach(d => {
            if (d && d.id !== null && d.id !== undefined) deals.push(d)
          })
        }
      })
      return deals
    },

    encontrarDealPorId(dealId) {
      const idStr = String(dealId)
      const deals = this.listarDealsDoQuadro()
      return deals.find(d => String(d.id) === idStr) || null
    },

    async atualizarTotalPropostasDeal(dealId) {
      const deal = this.encontrarDealPorId(dealId)
      if (!deal) return

      try {
        const res = await api.getDealProposals(dealId)
        const propostas = (res && res.data) ? res.data : []
        const total = propostas.reduce((acc, p) => {
          const v = Number(p && p.valor !== undefined ? p.valor : 0)
          return acc + (Number.isFinite(v) ? v : 0)
        }, 0)

        this.$set(deal, 'proposalCount', propostas.length)
        this.$set(deal, 'proposalTotal', total)
      } catch (e) {
        this.$set(deal, 'proposalCount', 0)
        this.$set(deal, 'proposalTotal', 0)
      }
    },

    async carregarTotaisPropostas() {
      const deals = this.listarDealsDoQuadro()
      const ids = Array.from(new Set(deals.map(d => d.id).filter(Boolean)))
      if (!ids.length) return

      const maxConcorrencia = 6
      const fila = [...ids]

      const worker = async () => {
        while (fila.length) {
          const id = fila.shift()
          // eslint-disable-next-line no-await-in-loop
          await this.atualizarTotalPropostasDeal(id)
        }
      }

      await Promise.all(Array.from({ length: Math.min(maxConcorrencia, ids.length) }, worker))
    },

    async recalcularPropostasOportunidade() {
      if (this.oportunidade && this.oportunidade.id) {
        await this.atualizarTotalPropostasDeal(this.oportunidade.id)
      }
    },

    novaEtapaBase() {
      return {
        name: '',
        color: '#283046',
        pipelineId: 0,
        description: '',
      }
    },
    novaOportunidadeBase() {
      return {
        title: '',
        estimatedValue: 0,
        companyId: 0,
        personId: 0,
        pipelineId: null,
        company: null,
        person: null,
      }
    },

    cadastrarNovaEtapa() {
      if (!this.novaEtapa.name) {
        this.$erro('Informe o nome para prosseguir.')
        return false
      }
      this.novaEtapa.pipelineId = this.funilSelecionado
      if (this.novaEtapa.pipelineId === 0) {
        this.$erro('Erro ao selecionar o funil, contate o suporte.')
        return false
      }
      this.novaEtapa.color = this.novaEtapa.color.hex || this.novaEtapa.color

      api.createPipelineStage(this.novaEtapa.pipelineId, { ...this.novaEtapa })
        .then(() => {
          this.$sucesso('Etapa cadastrada com sucesso.')
          this.carregarFunisEtapasOportunidades()
        })
        .catch(() => {
          this.$erro('Erro ao cadastrar etapa, tente novamente mais tarde.')
        })

      this.novaEtapa = this.novaEtapaBase()
      this.$refs.modalCadastroEtapa.hide()
      return true
    },

    cadastrarNovaOportunidade() {
      if (!this.validarNovaOportunidade()) return false

      this.novaOportunidade.companyId = this.novaOportunidade.company ? this.novaOportunidade.company.id : 0
      this.novaOportunidade.personId = this.novaOportunidade.person ? this.novaOportunidade.person.id : 0

      this.novaOportunidade.pipelineId = this.funilSelecionado
      const selectedFunil = Array.isArray(this.funis)
        ? this.funis.find(funil => funil.id === this.funilSelecionado)
        : null

      if (!selectedFunil) {
        this.$erro('Funil selecionado não encontrado.')
        return false
      }

      const firstStageId = selectedFunil.stages && selectedFunil.stages[0]
        ? selectedFunil.stages[0].id
        : null

      if (!firstStageId) {
        this.$erro('Funil selecionado não possui etapas.')
        return false
      }

      const payload = {
        title: this.novaOportunidade.title,
        estimatedValue: this.novaOportunidade.estimatedValue,
        companyId: this.novaOportunidade.companyId || null,
        personId: this.novaOportunidade.personId || null,
        pipelineId: this.novaOportunidade.pipelineId,
        stageId: firstStageId,
        ownerId: getUserInfo().id,
      }

      api.createDeal(firstStageId, payload)
        .then(() => {
          this.$sucesso('Oportunidade cadastrada com sucesso.')
          this.carregarFunisEtapasOportunidades()
        })
        .catch(err => {
          const data = err?.response?.data
          const backendMessage = data?.detail || data?.message || data?.title || (typeof data === 'string' ? data : null) || err?.message || 'Erro ao cadastrar oportunidade, tente novamente mais tarde.'
          this.$erro(backendMessage)
        })

      this.novaOportunidade = this.novaOportunidadeBase()
      this.$refs.modalCadastroOportunidade.hide()
      return true
    },

    empresaSelecionadaViaCnpj(empresa) {
      this.novaOportunidade.company = empresa || null
      if (empresa && empresa.id) {
        this.carregarPessoasDaEmpresa(empresa.id)
      } else {
        this.novaOportunidade.person = null
      }
    },

    async carregarPessoasDaEmpresa(empresaId, pessoaPreferidaId = null) {
      try {
        const response = await empresaApi.getPessoasEmpresa(empresaId)
        const pessoas = response.data || []
        if (this.$refs.pessoaSelect && this.$refs.pessoaSelect.recarregarItens) {
          await this.$refs.pessoaSelect.recarregarItens()
        }
        if (pessoas.length > 0) {
          const preferida = pessoaPreferidaId
            ? pessoas.find(p => String(p.id) === String(pessoaPreferidaId))
            : null
          this.novaOportunidade.person = preferida || pessoas[0]
        } else {
          this.novaOportunidade.person = null
        }
      } catch (error) {
        this.$erro('Nao foi possivel carregar as pessoas vinculadas a essa empresa.')
      }
    },

    abrirModalCriarPessoa() {
      if (this.$refs.modalCriarPessoa && this.$refs.modalCriarPessoa.show) {
        this.$refs.modalCriarPessoa.show()
      }
    },
    abrirModalCadastroOportunidade() {
      this.$refs.modalCadastroOportunidade.show()
    },
    async pessoaCriada(pessoaData) {
      if (this.$refs.pessoaSelect && this.$refs.pessoaSelect.recarregarItens) {
        await this.$refs.pessoaSelect.recarregarItens()
      }
      this.novaOportunidade.person = pessoaData
      this.$sucesso('Pessoa criada com sucesso!')
    },

    validarNovaOportunidade() {
      if (!this.novaOportunidade.company && !this.novaOportunidade.person) {
        this.$erro('Informe uma empresa ou uma pessoa.')
        return false
      }
      return true
    },

    abrirModalDetalhesOportunidade(oportunidade) {
      this.oportunidade = oportunidade
      this.$refs.modalDetalhesOportunidade.showModal()
    },

    isDealOverdue(deal) {
      if (!deal || !deal.expectedCloseDate) return false
      return moment(deal.expectedCloseDate).isBefore(moment(), 'day')
    },

    formatarValor(valor) {
      if (valor === null || valor === undefined || valor === '') return ' '
      try {
        return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(valor)
      } catch (error) {
        return valor
      }
    },

    selecionarFunil(value) {
      this.funilSelecionado = value
      this.carregarFunisEtapasOportunidades()
    },

    async onDealChanged(stage, changeEvt) {
      try {
        if (changeEvt && changeEvt.added) {
          const { element, newIndex } = changeEvt.added
          const deal = element
          const targetStageId = stage.id
          this.$isLoading(true)
          await api.updateDeal(deal.id, targetStageId, newIndex + 1)
          this.$sucesso('Oportunidade movida com sucesso.')
        } else if (changeEvt && changeEvt.moved) {
          const { element, newIndex } = changeEvt.moved
          const deal = element
          this.$isLoading(true)
          await api.updateDeal(deal.id, stage.id, newIndex + 1)
          this.$sucesso('Ordem atualizada com sucesso.')
        }
      } catch {
        this.$erro('Erro ao atualizar a oportunidade. Tente novamente.')
        this.carregarFunisEtapasOportunidades()
      } finally {
        this.$isLoading(false)
      }
    },
    onStageChanged(changeEvt) {
      if (changeEvt && changeEvt.moved) {
        const { element, newIndex } = changeEvt.moved
        const stage = element
        this.$isLoading(true)
        api.updatePipelineStageOrder(stage.id, newIndex + 1)
          .then(() => {
            this.$sucesso('Ordem da etapa atualizada com sucesso.')
            this.carregarFunisEtapasOportunidades()
          })
          .catch(() => {
            this.$erro('Erro ao atualizar a ordem da etapa. Tente novamente.')
            this.carregarFunisEtapasOportunidades()
          })
          .finally(() => {
            this.$isLoading(false)
          })
      }
    },
    deletarEtapa(stage) {
      this.$confirmar(
        'Deseja realmente excluir esta etapa?',
        'Essa ação não pode ser desfeita.',
        'question', 'danger',
      ).then(result => {
        if (!result || !result.value) return
        this.$isLoading(true)

        api.deletePipelineStage(stage.id).then(() => {
          this.$sucesso('Etapa excluída com sucesso.')
          this.carregarFunisEtapasOportunidades()
        }).catch(err => {
          this.$erro(err?.response?.data?.detail || 'Erro ao excluir etapa, tente novamente mais tarde.')
        }).finally(() => {
          this.$isLoading(false)
        })
      })
    },
  },
}
</script>
